export default {
	'delete-journal': 'Delete journal',
	'view-the-associated-invoice': 'View the associated invoice',
	'there-are-no-details': 'There are no details',
	'new-journal': 'New journal'
}